import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  Spinner,
  CardTable as EmployerDivisionTable
} from '../'

import {
  default as EmployerDivisionTableRow
} from './EmployerDivisionTableRow'

import {
  decodeBase64,
  getPageCursor,
  PageNavigationControl
} from '../../utils'

import {
  DEFAULT_RESULTS_PER_PAGE
} from '../../constants'

export class EmployerDivisions extends React.Component {
  static propTypes = {
    employer: PropTypes.string.isRequired,
    divisions: PropTypes.object,
    title: PropTypes.string,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    pageNav: new PageNavigationControl()
  }

  generateTableDataRows = (dataRows) => {
    let rows = dataRows.map(({ node: row }, i) => (
      <EmployerDivisionTableRow
        division={row}
        employerId={this.props.employer}
        key={i}
      />
    ))

    return rows
  }

  render() {
    if (this.props.loading) {
      return <Spinner />
    } else {
      let rows = this.generateTableDataRows(this.props.divisions.edges)
      let pageNav = this.state.pageNav

      return (
        <div className={this.props.className}>
          <EmployerDivisionTable
            heading={this.props.title}
            headingIcon={this.props.title ? 'groups' : null}
            columns={['Name', 'Notes', '']}
            tableDataRows={rows}
            nextPage={() => pageNav.nextPage(this.props.loadNextEmployerDivisions, this.props.employer, DEFAULT_RESULTS_PER_PAGE)}
            previousPage={() => pageNav.previousPage(this.props.loadPreviousEmployerDivisions, this.props.employer, DEFAULT_RESULTS_PER_PAGE)}
            onFirstPage={pageNav.firstPage}
            onLastPage={pageNav.lastPage}
            navigationButtons={true}
            startCursor={this.props.divisions.pageInfo.startCursor}
            totalCount={this.props.divisions.totalCount}
            resultsPerPage={DEFAULT_RESULTS_PER_PAGE}
            onPageNumberClick={pageNumber => this.props.refetch({ cursor: getPageCursor(pageNumber, DEFAULT_RESULTS_PER_PAGE) })}
          />
        </div>
      )
    }
  }
}

const getEmployerDivisions = gql`
  query($id: UUID, $resultsPerPage: Int!, $cursor: String) {
    divisions(employer_Id: $id, first: $resultsPerPage, after: $cursor) {
      totalCount
      edges {
        node {
          ...Division
          employer {
            id
            identity {
              id
            }
          }
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${fragments.division}
`

const getPreviousEmployerDivisions = gql`
  query($id: UUID, $resultsPerPage: Int!, $cursor: String) {
    divisions(employer_Id: $id, last: $resultsPerPage, before: $cursor) {
      totalCount
      edges {
        node {
          ...Division
          employer {
            id
            identity {
              id
            }
          }
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${fragments.division}
`

const withData = graphql(getEmployerDivisions, {
  options: ({ employer, cursor }) => ({
    variables: {
      id: decodeBase64(employer),
      resultsPerPage: DEFAULT_RESULTS_PER_PAGE,
      cursor
    }
  }),
  props: ({ data: { loading, refetch, divisions, fetchMore } }) => ({
    loading,
    refetch,
    divisions,
    loadNextEmployerDivisions: (employer, resultsPerPage) => {
      return fetchMore({
        query: getEmployerDivisions,
        variables: {
          id: decodeBase64(employer),
          resultsPerPage,
          cursor: divisions.pageInfo.endCursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEdges = fetchMoreResult.divisions.edges
          const pageInfo = fetchMoreResult.divisions.pageInfo

          return {
            divisions: {
              __typename: previousResult.divisions.__typename,
              edges: [...newEdges],
              pageInfo
            }
          }
        }
      })
    },
    loadPreviousEmployerDivisions: (employer, resultsPerPage) => {
      return fetchMore({
        query: getPreviousEmployerDivisions,
        variables: {
          id: decodeBase64(employer),
          resultsPerPage,
          cursor: divisions.pageInfo.startCursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEdges = fetchMoreResult.divisions.edges
          const pageInfo = fetchMoreResult.divisions.pageInfo

          return {
            divisions: {
              __typename: previousResult.divisions.__typename,
              edges: [...newEdges],
              pageInfo
            }
          }
        }
      })
    }
  })
})

export default withData(EmployerDivisions)



// WEBPACK FOOTER //
// ./src/components/employer-divisions/index.js